import { getVariantStyles } from '../utils/getVariantStyles';
export const bodyTextStyles = getVariantStyles('body-text');
export const breadcrumbTextStyles = getVariantStyles('breadcrumb-text');
export const buttonLinkStyles = getVariantStyles('button-link');
export const componentSubtitleStrikethroughStyles = getVariantStyles('component-subtitle-strikethrough');
export const componentSubtitleStyles = getVariantStyles('component-subtitle');
export const componentTitleLinkStyles = getVariantStyles('component-title-link');
export const componentTitleStyles = getVariantStyles('component-title');
export const contentSubtitleStyles = getVariantStyles('content-subtitle');
export const contentTitleStyles = getVariantStyles('content-title');
export const counterNumberStyles = getVariantStyles('counter-number');
export const dateTextMdStyles = getVariantStyles('date-text-md');
export const dateTextSmStyles = getVariantStyles('date-text-sm');
export const fieldHintTextStyles = getVariantStyles('field-hint-text');
export const fieldTextStyles = getVariantStyles('field-text');
export const fieldValidationStyles = getVariantStyles('field-validation');
export const footerLinkStyles = getVariantStyles('footer-link');
export const groupComponentTitleStyles = getVariantStyles('group-component-title');
export const introTextStyles = getVariantStyles('intro-text');
export const labelTitleStyles = getVariantStyles('label-title');
export const licensePlateStyles = getVariantStyles('license-plate');
export const linkTextStyles = getVariantStyles('link-text');
export const listTitleStyles = getVariantStyles('list-title');
export const notificationTextStyles = getVariantStyles('notification-text');
export const notificationTitleStyles = getVariantStyles('notification-title');
export const numberStyles = getVariantStyles('number');
export const pageTitleStyles = getVariantStyles('page-title');
export const priceTextXsStyles = getVariantStyles('price-text-xs');
export const priceTextSmStyles = getVariantStyles('price-text-sm');
export const priceTextMdStyles = getVariantStyles('price-text-md');
export const priceTextLgStyles = getVariantStyles('price-text-lg');
export const priceTextXlStyles = getVariantStyles('price-text-xl');
export const stickerTextSmStyles = getVariantStyles('sticker-text-sm');
export const stickerTextMdStyles = getVariantStyles('sticker-text-md');
export const stickerTextLgStyles = getVariantStyles('sticker-text-lg');
export const stickerTextNumberSmStyles = getVariantStyles('sticker-text-number-sm');
export const stickerTextNumberMdStyles = getVariantStyles('sticker-text-number-md');
export const suggestionTextStyles = getVariantStyles('suggestion-text');
export const supportTextStyles = getVariantStyles('support-text');
export const tagTextStyles = getVariantStyles('tag-text');
export const tooltipTextStyles = getVariantStyles('tooltip-text');
export const tooltipTitleStyles = getVariantStyles('tooltip-title');
export const uspTextSmStyles = getVariantStyles('usp-text-sm');
export const uspTextMdStyles = getVariantStyles('usp-text-md');
//# sourceMappingURL=index.js.map